import { defineMessages } from 'react-intl'

const messages = {
  moveReadyButton: {
    id: 'app.components.change-order-status-button.move-ready-button',
    defaultMessage: 'Move to ready',
  },
  removeButton: {
    id: 'app.components.change-order-status-button.remove-button',
    defaultMessage: 'Remove from pallet',
  },
  toInProgressButton: {
    id: 'app.components.change-order-status-button.to-in-progress-button',
    defaultMessage: 'Move to in-progress',
  },
  reason: {
    id: 'app.components.change-order-status-button.reason',
    defaultMessage: 'Moved to In-Progress',
  },
  awaitingFinalPo: {
    id: 'app.components.change-order-status-button.awaiting-final-po',
    defaultMessage: 'Awaiting PO number',
  },
  awaitingFinalPoTooltip: {
    id: 'app.components.change-order-status-button.awaiting-final-po-tooltip',
    defaultMessage: 'Will unlock when purchase order number is received',
  },
  finalPoReceivedToast: {
    id: 'app.components.change-order-status-button.final-po-received-toast',
    defaultMessage: 'Order #{orderId} — labels can now be printed and the order moved to Ready.',
  },
}

export default defineMessages(messages)
